import { InjectionToken } from '@angular/core';

export const WS_URL = new InjectionToken('App config');
export const accountFeatureKey = 'accountFeature';
